"use client";

import { useEffect, useRef, useState } from "react";
import WhatsAppButton from "./WhatsAppButton";
import CallButtonsStack from "./CallButtonsStack";
import BackToTop from "./BackToTop";

export default function FloatingActions() {
  const [callOpen, setCallOpen] = useState(false);

  // suspend everything while user is actively scrolling,
  // then allow after a short idle delay (page "stable")
  const [suspend, setSuspend] = useState(false);
  const idleTimer = useRef<number | null>(null);

  useEffect(() => {
    const clear = () => {
      if (idleTimer.current) {
        window.clearTimeout(idleTimer.current);
        idleTimer.current = null;
      }
    };

    const onScroll = () => {
      // while scrolling -> suspend
      setSuspend(true);
      clear();

      // after user stops scrolling -> unsuspend
      idleTimer.current = window.setTimeout(() => {
        setSuspend(false);
      }, 500);
    };

    window.addEventListener("scroll", onScroll, { passive: true });
    // initialize once
    onScroll();

    return () => {
      window.removeEventListener("scroll", onScroll);
      clear();
    };
  }, []);

  return (
    <>
      {/* Call hub above WhatsApp (mobile only) */}
      <CallButtonsStack
        suspend={suspend}
        onOpenChange={(open) => setCallOpen(open)}
      />

      {/* WhatsApp bottom-right */}
      <WhatsAppButton suspend={suspend} />

      {/* Back to top centered; hidden if Call menu open */}
      <BackToTop disabled={callOpen} suspend={suspend} />
    </>
  );
}
